/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_ChipInputs */

const en_funnel_sq_chip = /** @type {(inputs: Funnel_Sq_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for grad students & researchers`)
};

const es_funnel_sq_chip = /** @type {(inputs: Funnel_Sq_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para estudiantes de posgrado e investigadores`)
};

/**
* | output |
* | --- |
* | "Built for grad students & researchers" |
*
* @param {Funnel_Sq_ChipInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_chip = /** @type {((inputs?: Funnel_Sq_ChipInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_ChipInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_chip(inputs)
	return en_funnel_sq_chip(inputs)
});